import { ChangeDetectionStrategy, Component, InputSignal, input } from '@angular/core';
import { RouterLink } from '@angular/router';

import { BlockDirective, ElemDirective } from '@rt-tools/core';

export interface IBreadcrumbItem {
    readonly label: string;
    readonly link?: string;
}

const BEM_BLOCK: string = 'sc-breadcrumbs';

@Component({
    selector: 'sc-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrl: './breadcrumbs.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        // angular
        RouterLink,

        // rt-tools
        BlockDirective,
        ElemDirective,
    ],
    host: {
        class: BEM_BLOCK,
    },
})
export class BreadcrumbsComponent {
    public readonly items: InputSignal<readonly IBreadcrumbItem[]> = input<readonly IBreadcrumbItem[]>([]);
}
